module.exports = {"230606007":"和平街道","230606008":"庆葡街道","230606009":"新华街道","230606010":"高平街道","230606011":"林源街道","230606012":"和苑街道","230606013":"同福街道","230606100":"大同镇","230606101":"高台子镇","230606102":"太阳升镇","230606103":"林源镇","230606200":"祝三乡","230606203":"老山头乡","230606205":"八井子乡","230606206":"双榆树乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230606.json
// module id = 824
// module chunks = 0